import { useSelector } from 'react-redux'

import { getRequestPaymentCustomers } from '../../../data/requestPayment/requestPaymentSelectors'
import { companyMessages } from '../../constants/appConstants'

type CompanyWarning = string
type CompaniesWithWarnings = Record<string, CompanyWarning[]>

export const useCompaniesWithWarnings = (): CompaniesWithWarnings => {
  const customers = useSelector(getRequestPaymentCustomers)

  /* all these enrollmentjan and enrollmentfeb belong to Solera */
  const companiesWithWarnings: CompaniesWithWarnings = {
    aps: [companyMessages.NUCLEAR_BADGED],
    att: [companyMessages.MULTIPLE_INSTANCES],
    attunion: [companyMessages.MULTIPLE_INSTANCES],
    bluepearlvet: [companyMessages.MULTIPLE_INSTANCES],
    'bluepearlvet-2': [companyMessages.MULTIPLE_INSTANCES],
    enrollment: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    enrollmentjan: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    enrollmentfeb: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    enrollmentmar: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    enrollmentapr: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    enrollmentmay: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    enrollmentjun: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    enrollmentjul: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    enrollmentaug: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    enrollmentsep: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    enrollmentoct: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    enrollmentnov: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    enrollmentdec: [companyMessages.LIMITED_ACCESS_AND_MODIFIED_REFERRALS],
    mgb: [companyMessages.MULTIPLE_INSTANCES],
    mgbhealthplan: [companyMessages.MULTIPLE_INSTANCES],
    nextera: [companyMessages.NUCLEAR_BADGED],
    qualcomm: [companyMessages.MULTIPLE_INSTANCES],
    'qualcomm-16eap': [companyMessages.MULTIPLE_INSTANCES],
    vca: [companyMessages.MULTIPLE_INSTANCES],
    'vca-2': [companyMessages.MULTIPLE_INSTANCES],
    united: [companyMessages.MULTIPLE_INSTANCES],
    unitedgroundexpress: [companyMessages.MULTIPLE_INSTANCES],
    turner: [companyMessages.MULTIPLE_INSTANCES],
    turner2: [companyMessages.MULTIPLE_INSTANCES],
  }

  // remove the multiple instance customers that have isOneMicrositeMemberSubpopulationEnabled enabled
  Object.keys(companiesWithWarnings).forEach((company) => {
    if (customers?.find((info) => info.value === company)?.is_one_microsite_member_subpopulation_enabled === 'true') {
      delete companiesWithWarnings[company]
    }
  })

  return companiesWithWarnings
}
